import Navbar from "../components/navbar"
import { useState } from "react"
import { FaBars } from "react-icons/fa"
import ProgressBar from "../components/progress-bar"
import { Drawer, Switch, DatePicker } from "antd"
import FloatingInput from "../components/floatingInput"
import Footer from "../components/footer"
import { Link } from "react-router-dom"
import { AiOutlineInfo } from "react-icons/ai"

const ReferencesPage = () => {
    const [navShown, setNavShown] = useState("hidden")
    const [showBar, setShowBar] = useState(true)
    const [showXmark, setShowXmark] = useState("hidden")
    const [openDrawer, setOpenDrawer] = useState(false)

    const openNav = () => {
        setNavShown("block")
        setShowBar("hidden")
        setShowXmark("inline")
    }
    const closeNav = () => {
        setNavShown("hidden")
        setShowBar("inline")
        setShowXmark("hidden")
    }

    const DrawerFooter = () => {
        return (
            <div className="flex justify-center items-center py-2">
                <div className="flex flex-col gap-y-1 w-fit">
                    <button className="bg-cyan-400 py-2 rounded-full px-20" onClick={() => setOpenDrawer(false)}>DONE</button>
                    <button className="underline text-cyan-600" onClick={() => setOpenDrawer(false)}>CANCEL</button>
                </div>
            </div>
        )
    }


    return (
        <Navbar active={"profile"} navShow={navShown}>
            <div className="flex w-full bg-cyan-900 items-center fixed z-20">
                <FaBars className={`text-[20px] text-white relative left-4 lg:hidden ${showBar}`} onClick={openNav} />
                <span className={`text-[25px] ${showXmark} text-white font-bold relative left-72`} onClick={closeNav}>
                    X
                </span>
                <h1 className="text-center text-white py-4 w-full font-bold">References</h1>
            </div>
            <div className="relative top-14 pb-48">
                <div className="p-3 lg:px-8">
                    <div>
                        <h1 className="font-semibold mb-2">Application progress</h1>
                        <ProgressBar active={"references"} />
                    </div>
                    <p className="text-sm mt-7">
                        Please provide supervisor references whom we may contact from within the last 12 months of employment. Please note that specific reference requirements vary by facility.
                    </p>
                    <div className="flex justify-between items-center mt-6">
                        <h1 className="font-semibold">Reference #1</h1>
                        <span className="uppercase underline text-cyan-900 text-sm cursor-pointer" onClick={() => setOpenDrawer(true)}>Edit</span>
                    </div>

                    <div className="mt-4">
                        <div className="p-3 rounded-lg flex flex-col w-full gap-y-2" style={{ boxShadow: "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px" }}>
                            <div className="flex justify-between">
                                <span className="font-semibold">Facility</span>
                                <span>
                                    -
                                    {/* details  */}
                                </span>
                            </div>
                            <div className="flex justify-between">
                                <span className="font-semibold">Name*</span>
                                <span>
                                    -
                                    {/* details  */}
                                </span>
                            </div>
                            <div className="flex justify-between">
                                <span className="font-semibold">Title</span>
                                <span>
                                    -
                                    {/* details  */}
                                </span>
                            </div>
                            <div className="flex justify-between">
                                <span className="font-semibold">Email</span>
                                <span>
                                    -
                                    {/* details  */}
                                </span>
                            </div>
                            <div className="flex justify-between">
                                <span className="font-semibold">Telephone</span>
                                <span>
                                    -
                                    {/* details  */}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="mt-6">
                        <button className="uppercase border border-cyan-500 px-4 py-2 rounded-full" onClick={() => setOpenDrawer(true)}>
                            Add Reference 1
                        </button>
                    </div>


                </div>
                <div className="fixed bottom-0 w-full">
                    <div className="bg-white p-3 border-t-2">
                        <div className="flex items-center gap-x-1">
                            <span className="h-5 w-5 rounded-full border border-blue-500 flex justify-center items-center">
                                <AiOutlineInfo className="text-blue-500" />
                            </span>
                            <span className="text-blue-500">Add 3 references to continue</span>
                        </div>
                        <div className="flex gap-x-4 mt-2">
                            <button disabled={true} className="uppercase border border-cyan-400 py-1 px-6 rounded-full disabled:cursor-not-allowed disabled:bg-gray-400 disabled:border-0 disabled:text-gray-200 text-sm text-center">
                                save & continue
                            </button>
                            <Link to={"/education"} className="uppercase border border-cyan-400 py-1 px-6 rounded-full text-sm text-center">
                                skip to next section
                            </Link>
                        </div>
                    </div>
                    <Footer></Footer>
                </div>
            </div>
            <Drawer footer={<DrawerFooter />} open={openDrawer} title="Reference 1" onClose={() => setOpenDrawer(false)}>
                <div className="flex gap-y-5 flex-col">
                    <div>
                        <FloatingInput title={"Facility"} id={"facility"} />
                    </div>
                    <div>
                        <FloatingInput title={"Name*"} id={"name"} />
                    </div>
                    <div>
                        <FloatingInput title={"Title"} id={"title"} />
                    </div>
                    <div>
                        <FloatingInput title={"Email"} id={"email"} />
                    </div>
                    <div>
                        <FloatingInput title={"Phone"} id={"phone"} />
                    </div>
                    <div className="flex gap-x-1">
                        <span className="w-5 h-5 rounded-full border border-blue-500 flex justify-center items-center">
                            <AiOutlineInfo className="text-blue-500" />
                        </span>
                        <span className="text-xs text-blue-500">
                            An email or phone number is required for each reference
                        </span>
                    </div>
                </div>
            </Drawer>
        </Navbar>
    )
}

export default ReferencesPage